import React, { useState, useEffect, useContext } from 'react';
import { Row } from 'reactstrap';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import CreateBatchPopUp from './CreateBatchPopUp';
import EditBatch from './EditBatch';
import DeleteBatch from './DeleteBatch';
import { cx, css } from '@emotion/css';
import * as assignmentStyles from '../assignments/assignments.style';
import BatchNewCard from '../Card/BatchNewCard';
import batchHeroImg from '../../assets/gen_images/batcheshero.png';
import spellBowlImg from '../../assets/gen_images/batchesicon.png';
import mathsImg from '../../assets/gen_images/mathematics.png';
import generalMathImg from '../../assets/gen_images/general_math.png';
import { UserContext } from '../UserContext';

Amplify.configure(config);

const pageBgStyles = css`
  background-color: #fdfbf7;
  background-image: 
    radial-gradient(at 100% 0%, rgba(241, 102, 2, 0.04) 0px, transparent 50%),
    radial-gradient(at 0% 100%, rgba(244, 203, 14, 0.02) 0px, transparent 50%);
  min-height: 100vh;
  padding-bottom: 100px;
  overflow-x: hidden;
`;

const headerStyles = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    border-bottom: 1px solid rgba(241, 102, 2, 0.08);
    padding-bottom: 1.2rem;

    @media (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 1.2rem;
      margin-bottom: 1.5rem;
      padding-bottom: 1.2rem;
    }
  `,
  leftCol: css`
    flex: 1;
    max-width: 850px;
  `,
  topLabel: css`
    font-family: 'Inter', sans-serif;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: rgba(241, 102, 2, 0.7);
    margin-bottom: 0.6rem;
    display: block;
  `,
  heading: css`
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 2.4rem;
    font-weight: 800;
    font-style: italic;
    line-height: 1.05;
    margin: 0 0 0.5rem 0;
    letter-spacing: -0.02em;
    text-transform: uppercase;

    .orange-part {
      color: #f16602;
      margin-right: 0.6rem;
      display: inline-block;
    }

    .outline-part {
      color: transparent;
      -webkit-text-stroke: 1.5px rgba(241, 102, 2, 0.25);
      font-weight: 900;
      display: inline-block;
    }

    @media (max-width: 768px) {
      font-size: 1.8rem;
      
      .outline-part {
        -webkit-text-stroke: 1px rgba(241, 102, 2, 0.25);
      }
    }
  `,
  description: css`
    font-family: 'Inter', sans-serif;
    font-size: 1.05rem;
    color: #554a42;
    line-height: 1.6;
    margin: 0;
    max-width: 700px;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  `,
  rightCol: css`
    display: flex;
    align-items: center;
    gap: 1.2rem;
    flex-wrap: wrap;

    @media (max-width: 991px) {
      width: 100%;
    }
  `,
  button: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1.5px solid rgba(241, 102, 2, 0.25);
    border-radius: 9999px;
    padding: 14px 28px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #f16602;
    text-transform: uppercase;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: #f16602;
      border-color: #f16602;
      color: #ffffff;
      text-decoration: none;
      box-shadow: 0 6px 20px rgba(241, 102, 2, 0.15);
    }

    @media (max-width: 576px) {
      width: 100%;
      padding: 12px 24px;
    }
  `
};

function CreateClasses(props) {
  const { user } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenquestion, setIsOpenquestion] = useState(false);
  const [isShowDeleteEvent, setIsShowDeleteEvent] = useState(false);
  const [batches, set_batches] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);

  const [batchid, set_batchid] = useState('');
  const [batch_owner, set_batch_owner] = useState('');
  const [batch_name, set_batch_name] = useState('');
  const [students, set_students] = useState('');

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      getToken();
    }
    document.title = 'Batches | QuizWizard';
  }, [user]);

  const togglePopup = () => setIsOpen(!isOpen);

  const computeAnswer = (answer) => {
    setIsOpen(false);
    set_batches([]);
    getToken();
  };

  const completedeletion = (answer) => {
    setIsShowDeleteEvent(false);
    set_batches([]);
    getToken();
  };

  const showeditquestions = (id, owner, name, students) => {
    set_batchid(id);
    set_batch_owner(owner);
    set_batch_name(name);
    set_students(students);
    setIsOpenquestion(true);
  };

  const showdeletebatchwindow = (id, owner, name, students) => {
    set_batchid(id);
    set_batch_owner(owner);
    set_batch_name(name);
    set_students(students);
    setIsShowDeleteEvent(true);
  };

  const getToken = async () => {
    try {
      const userObj = await Auth.currentAuthenticatedUser();
      const res = await Auth.currentSession();
      const jwt = res.getAccessToken().getJwtToken();
      const username = userObj.username.includes("Google_") ? userObj.attributes['email'] : userObj.username;
      getEventsfromDB(username, jwt);
    } catch (error) {
      console.error("Auth error:", error);
    }
  };

  const getEventsfromDB = async (username, jwt) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },
        body: JSON.stringify({ username: username }),
      };
      const response = await fetch(`https://api.quizwizard.net/quiz/listbatchesbyowner`, requestOptions);
      const data = await response.json();
      
      let loopData = [];
      data.forEach(item => {
        if (item.events) {
          loopData.push(...item.events);
        }
      });

      set_batches(loopData);
      set_loadedevents(true);
    } catch (error) {
      console.error("Error fetching batches:", error);
      set_loadedevents(true);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
  };

  return (
    <div className={cx(pageBgStyles)}>
      {isOpen && (
        <CreateBatchPopUp
          handleClose={togglePopup}
          selected={(answer) => computeAnswer(answer)}
        />
      )}
      {isOpenquestion && <EditBatch />}
      {isShowDeleteEvent && (
        <DeleteBatch
          closedeleteevents={(answer) => completedeletion(answer)}
          closedeleteeventwindow={() => setIsShowDeleteEvent(false)}
          batch_id={batchid}
          batch_owner={batch_owner}
          batch_name={batch_name}
          students={students}
        />
      )}

      <div className="container" style={{ marginTop: '1rem' }}>
        {/* Curated Header Layout for Batches Section */}
        <div className={cx(headerStyles.container)}>
          <div className={cx(headerStyles.leftCol)}>
            <span className={cx(headerStyles.topLabel)}>STUDENT GROUPS</span>
            <h1 className={cx(headerStyles.heading)}>
              <span className="orange-part">Your Active</span>
              <span className="outline-part">Batches</span>
            </h1>
            <p className={cx(headerStyles.description)}>
              Manage student groups, coordinate tracks, configure module access, and overview learning progression in one centralized portal.
            </p>
          </div>
          
          <div className={cx(headerStyles.rightCol)}>
            {/* Create New Batch Action Button */}
            <button className={cx(headerStyles.button)} onClick={() => setIsOpen(true)}>
              + Create New Batch
            </button>
          </div>
        </div>

        {loadedevents ? (
          <div className={cx(assignmentStyles.challengeGrid)} style={{ padding: '0 0 80px 0' }}>
            <BatchNewCard
              isCreate={true}
              imgsrc={batchHeroImg}
              onClick={() => setIsOpen(true)}
            />
            {batches.map((batch) => (
              <BatchNewCard
                key={batch.id}
                id={batch.id}
                name={batch.name}
                imgsrc={(batch.category && batch.category.toLowerCase().includes('spellbowl')) || (batch.name && batch.name.toLowerCase().includes('spellbowl')) ? spellBowlImg : 
                       (batch.category && batch.category.toLowerCase().includes('mathbowl')) || 
                       (batch.name && batch.name.toLowerCase().includes('mathbowl')) ? mathsImg : 
                       (batch.category && (batch.category.toLowerCase().includes('mathematics') || batch.category.toLowerCase().includes('maths'))) || 
                       (batch.name && (batch.name.toLowerCase().includes('mathematics') || batch.name.toLowerCase().includes('maths'))) ? generalMathImg : 
                       'https://api.quizwizard.net/assets/' + batch.category + '.png'}
                category={batch.category}
                owner={batch.classowner}
                students={batch.members}
                onDelete={() => showdeletebatchwindow(batch.id, batch.classowner, batch.name, batch.members)}
                onEdit={() => showeditquestions(batch.id, batch.classowner, batch.name, batch.members)}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-5">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="mt-3">Loading your batches...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CreateClasses;
